import { render, staticRenderFns } from "./CorporationSelect.vue?vue&type=template&id=2c26ad52&"
import script from "./CorporationSelect.vue?vue&type=script&lang=js&"
export * from "./CorporationSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports